import React from 'react'
import Button from 'antd/lib/button'
import 'antd/lib/button/style/index.css'


export default class ConfirmButton extends Button {
  state = {
    showConfirm: false,
  }

  showConfirm = () => this.setState({showConfirm: true})
  hideConfirm = () => this.setState({showConfirm: false})

  renderConfirmButtons = () => ( // eslint-disable-line react/display-name
    <div style={{display: 'inline-block'}}>
      <Button {...this.props} title="confirm"
        className="ant-btn ant-btn-sm ant-btn-danger ant-btn-background-ghost ant-btn-dashed"
        style={{
          borderColor: 'gray',
          borderRadius: '4px 0px 0px 4px',
          borderRightWidth: '0px',
          color: 'gray',
        }}
      >✓</Button>
      <Button title="abort" onClick={this.hideConfirm}
        className="ant-btn ant-btn-sm ant-btn-danger ant-btn-background-ghost ant-btn-dashed"
        style={{
          borderRadius: '0px 4px 4px 0px',
        }}
      >✗</Button>
    </div>
  )

  render() {
    return (
      !this.state.showConfirm
        ? <Button {...this.props} onClick={this.showConfirm}>{this.props.children}</Button>
        : this.renderConfirmButtons()
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/ConfirmButton/index.tsx